import React, { useState, useEffect, useRef } from 'react';
import { Grid, Card, CardContent, CardMedia, Typography, Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { styled } from '@mui/system';

const StyledGridContainer = styled(Grid)({
  display: 'flex',
  flexWrap: 'wrap',
});

const StyledGridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: '100%',
  minWidth: '100%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    margin: '0 auto',
  },
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '12px'
}));

const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  objectFit: 'cover',
  minHeight: '140px',
  height: '100%',
  backgroundColor: '#f0f0f0',
}));

const ItemsGrid = ({ items, isRecipes }) => {
  const [selectedAge, setSelectedAge] = useState(localStorage.getItem('selectedAge') || '');

  useEffect(() => {
    localStorage.setItem('selectedAge', selectedAge);
  }, [selectedAge]);

  const handleSelectChange = (event) => {
    setSelectedAge(event.target.value);
  };

  const filteredItems = selectedAge
     ? items.filter(item => {
         const itemAge = parseInt(item.age, 10);
         return itemAge <= parseInt(selectedAge, 10);
       }).sort((a, b) => a.name.localeCompare(b.name))
     : items.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Box>
      <FormControl fullWidth sx={{ maxWidth: { xs: '100%', sm: 320 }, my: 2 }}>
        <InputLabel id="age-select-label">Wiek dziecka</InputLabel>
        <Select
          labelId="age-select-label"
          value={selectedAge}
          onChange={handleSelectChange}
          label="Wiek dziecka"
        >
          <MenuItem value="6">+6 miesięcy</MenuItem>
          <MenuItem value="9">+9 miesięcy</MenuItem>
          <MenuItem value="12">+12 miesięcy</MenuItem>
          <MenuItem value="18">+18 miesięcy</MenuItem>
          <MenuItem value="24">+2 lata</MenuItem>
          <MenuItem value="36">+3 lata</MenuItem>
          <MenuItem value="60">+5 lat</MenuItem>
          <MenuItem value="144">+12 lat</MenuItem>
        </Select>
      </FormControl>
      <StyledGridContainer container spacing={1}>
        {filteredItems.map((item) => (
          <StyledGridItem item xs={6} sm={6} md={3} key={item.id}>
            <Link to={isRecipes ? `/przepisy/${item.id}` : `/encyklopedia/${item.id}`} style={{ textDecoration: 'none', flexGrow: 1 }}>
              <StyledCard>
                <LazyLoadImage
                  component="img"
                  height="140"
                  width="140"
                  image={isRecipes ? `/images/recipes/${item.id}.jpeg` : `/images/products/${item.id}.jpeg`}
                />
                <StyledCardContent>
                  <Typography gutterBottom variant="h6" component="div">
                    {item.name}
                  </Typography>
                </StyledCardContent>
              </StyledCard>
            </Link>
          </StyledGridItem>
        ))}
      </StyledGridContainer>
    </Box>
  );
};

const LazyLoadImage = ({ component, height, width, image, placeholder }) => {
  const imgRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, []);

  return (
    <div ref={imgRef}>
        <StyledCardMedia
          component={component}
          height={height}
          width={width}
          image={image}
        />
    </div>
  );
};

export default ItemsGrid;